import { useQuery } from '@tanstack/react-query'
import { getStudentAwardPreview } from '../requests'

type UseGetStudentAwardPreviewParams = {
  programId: number
  purseId: number | null
  studentIds: number[]
  enabled: boolean
}

export function useGetStudentAwardPreview({
  programId,
  purseId,
  studentIds,
  enabled,
}: UseGetStudentAwardPreviewParams) {
  return useQuery({
    queryKey: ['student-award-preview', programId, purseId, studentIds],
    queryFn: () =>
      getStudentAwardPreview({
        programId,
        purseId: purseId!,
        studentIds,
      }),
    enabled: enabled,
    staleTime: 0,
  })
}
